// The "tv" service channel between the room and the television's feed app,
// and the picture's fixed layout. Both sides import this file: the page
// draws a game's screenshot into the window the app leaves for it.

export const TV_SERVICE = "tv";

/** The picture in logical pixels. */
export const PICTURE = { w: 320, h: 240 } as const;
/** The window the page fills with the featured game's screenshot. */
export const SHOT = { x: 12, y: 36, w: 136, h: 102 } as const;
/** Letters the caption gains per second; the page's voice keeps the same pace. */
export const CAPTION_RATE = 17;

export interface FeedItem {
  id: string;
  title: string;
  author: string;
  tagline: string;
  /** Display names of the devices the game runs on, in English. */
  devices: string[];
  /** The same devices by id, for a guest that names them in `lang`. */
  deviceIds?: string[];
  /** The game's two cover colours. */
  colors: [string, string];
}

/** page -> app */
export type TvHostLine =
  /** `lang`: the language the room shows (src/core/i18n.ts), `"en"` or `"ja"`. The room loads again when it changes. */
  | { t: "feed"; items: FeedItem[]; lang?: "en" | "ja" }
  /** Wall-clock time as the station shows it, for example "19:42". */
  | { t: "clock"; s: string };

/** app -> page */
export type TvGuestLine =
  /** The featured game changed; `index` counts from 0. */
  | { t: "show"; id: string; index: number }
  /** The announcer starts reading this line now. */
  | { t: "say"; text: string }
  /** The viewer chose the featured game. */
  | { t: "open"; id: string };
